import { render } from "./VideoWallPresetSelectItemDeleteButton.vue?vue&type=template&id=366450ee&ts=true"
import script from "./VideoWallPresetSelectItemDeleteButton.vue?vue&type=script&lang=ts"
export * from "./VideoWallPresetSelectItemDeleteButton.vue?vue&type=script&lang=ts"

import "./VideoWallPresetSelectItemDeleteButton.vue?vue&type=style&index=0&id=366450ee&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__